import { Injectable, inject } from '@angular/core';
import { AppSettingsStore } from '../../state/app-settings-store/app-settings-store';
import { AppSettingsDto, UploaderSettingsDto } from '../models/app-settings.model';
import { GenericResponse } from '@app/core/models/generic-response';
import { catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { LoggingService } from '@app/core/services/logging.service';
import { logFinalEffectiveConfiguration } from '@app/core/configuration/configuration-diagnostics';
import { PlatformStsConfigurationLoader } from '@app/core/configuration/platform-sts-configuration.loader';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  private readonly loggingService = inject(LoggingService);
  private readonly platformConfigurationLoader = inject(PlatformStsConfigurationLoader);

  constructor(
    private http: HttpClient,
    private appSettingsStore: AppSettingsStore
  ) {}

  loadAppSettings(): Observable<AppSettingsDto> {
      const apiUrl = `${environment.apiRoot}settings`;


      const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    this.appSettingsStore.startLoading();

    return this.http.get<GenericResponse<AppSettingsDto>>(apiUrl, { headers }).pipe(
      map(response => {
        if (response.success) {
          this.appSettingsStore.updateSettings(response.data);
          this.appSettingsStore.stopLoading();
          logFinalEffectiveConfiguration(
            this.platformConfigurationLoader.source,
            this.platformConfigurationLoader.effectiveConfiguration,
            this.platformConfigurationLoader.publicConfiguration,
            response.data
          );
          return response.data;
        } else {
          throw new Error(response.message || 'Failed to load app settings.');
        }
      }),
      catchError(error => {
        this.loggingService.error('Error loading application settings.', error);
        return throwError(() => error);
      })
    );
  }
}
